import axios from 'axios';
import { useContext } from 'react';
import { UserContext } from '../../context/UserContext';

export const useSWRAxiosMutation = () => {
    const { session } = useContext(UserContext);

    async function get(url: string) {
        return axios
            .get(url, {
                headers: {
                    Authorization: session.jwt
                }
            })
            .then(res => res.data);
    }

    async function post<D>(url: string, arg: D) {
        return axios
            .post(url, arg, {
                headers: {
                    Authorization: session.jwt
                }
            })
            .then(res => res.data);
    }

    async function put<D>(url: string, arg: D) {
        return axios
            .put(url, arg, {
                headers: {
                    Authorization: session.jwt
                }
            })
            .then(res => res.data);
    }

    async function patch<D>(url: string, arg?: D) {
        return axios
            .patch(url, arg, {
                headers: {
                    Authorization: session.jwt
                }
            })
            .then(res => res.data);
    }

    const remove = async (url: string) => {
        return axios
            .delete(url, {
                headers: {
                    Authorization: session.jwt
                }
            })
            .then(res => res.data);
    };

    return { post, put, remove, patch, get };
};
